import { IRootState } from '@src/store';

export const uiMobileFilterOverlay = (state:IRootState) => state.ui.uiMobileFilterOverlay;
export const uiMobileNoScrolling = (state:IRootState) => state.ui.uiMobileNoScrolling;
